import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import useSensorSocket, { SENSOR_DATA_EVENT } from '../../hooks/useSensorSocket';
import { patchLiveReading, setSocketConnected } from '../../store/slices/sensorDataSlice';

/** App-wide bridge: forwards socket sensor:data events into the sensorData Redux slice. */
export default function SensorSocketBridge() {
  const dispatch = useDispatch();

  const handleSocketEvent = useCallback((event) => {
    if (event?.type === 'connected') {
      dispatch(setSocketConnected(true));
      return;
    }
    if (event?.type === 'disconnected') {
      dispatch(setSocketConnected(false));
      return;
    }
    if (event?.type === SENSOR_DATA_EVENT && event.reading) {
      dispatch(patchLiveReading(event.reading));
    }
  }, [dispatch]);

  useSensorSocket(handleSocketEvent);
  return null;
}
